// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MiniAudioPlayer__audio-player-b7bdcf {
  border-top: 1px solid var(--base-30);
  z-index: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/MiniAudioPlayer/MiniAudioPlayer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,aAAA;AACF","sourcesContent":[".audio-player {\n  border-top: 1px solid var(--base-30);\n  z-index: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"audio-player": `MiniAudioPlayer__audio-player-b7bdcf`,
	"audioPlayer": `MiniAudioPlayer__audio-player-b7bdcf`
};
module.exports = ___CSS_LOADER_EXPORT___;
